<template>
  <div>
    <div class="bid-now" v-loading="loading">
      <div class="spaceCenter bid-title">
        <svg-icon class="icon" aria-hidden="true" icon-class="trn-jingbiao" />
        <div>Bid Now</div>
      </div>
      <div class="unit-input">
        <div class="spaceBetween">
          <span class="word-sm">
            <img
              src="@/assets/image/exchange/jiantou.svg"
              style="width:0.16rem;"
            />
            1 Rep = $ 0.8
          </span>
          <span class="word-sm">
            Balance :
            <big-number :number.sync="balance" />
          </span>
        </div>
        <div class="spaceBetween exchange-item">
          <div class="spaceLeft unit-icon">
            <img
              src="@/assets/image/exchange/tat.png"
              style="width:0.36rem;margin-right:0.08rem;"
            />Rep
            <!-- <el-dropdown @command="changeType">
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
              :disabled="currentcumulativebid <= 0"
            >
              <div slot="content">
                You have already used UNIT to participate in this round of BID,
                and you<br />can only choose UNIT to continue participating in
                this round of BID.
              </div>
              <div class="word-sm-black">
                {{ type
                }}<i
                  class="el-icon-arrow-down el-icon--right"
                  style="font-size:0.14rem;"
                ></i>
              </div>
            </el-tooltip>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                command="UNIT"
                v-if="type == 'TAT'"
                :disabled="currentcumulativebid > 0"
                >UNIT</el-dropdown-item
              >
              <el-dropdown-item
                command="TAT"
                v-if="type == 'UNIT'"
                :disabled="currentcumulativebid > 0"
                >TAT</el-dropdown-item
              >
            </el-dropdown-menu>
            </el-dropdown>-->
          </div>
          <div style="flex:1 0 0;">
            <el-input
              class="exchange-input"
              placeholder="0.00"
              v-model="bidNum"
              @change="checkNumber"
            />
            <div class="text-right word-sm-num">$ {{ changeMoney }}</div>
          </div>
        </div>
        <P class="des">Minimum bid 1 Rep</P>
      </div>

      <div class="checkLoginBtn">
        <div
          class="spaceBetween"
          style="margin-top:0.7rem;margin-bottom:0.13rem"
        >
          <span class="word-sm">Current cumulative bid</span>
          <div>
            <span class="word-sm-num">
              <big-number :number.sync="currentcumulativebid" />
            </span>
            <span class="word-sm">Rep</span>
          </div>
        </div>
        <check-login-btn
          @clickHandle="submit"
          :disabled="submitBtnText != 'Submit' || +bidNum <= 0"
          :label.sync="submitBtnText"
        />
      </div>
    </div>
    <detail-btn
      @clickHandle="setShowDetail"
      label="View History"
      style="margin:0.88rem 0 0 0;"
    />
  </div>
</template>

<script>
import detailBtn from "@/components/DetailBtn/index.vue";
import checkLoginBtn from "@/components/CheckLoginBtn/index.vue";
import { toBigNum } from "@/utils/bigNumberTran.js";
import { isIntNum } from "@/utils/index.js";
export default {
  components: { detailBtn, checkLoginBtn },
  data() {
    return {
      loading: false,
      type: "TAT",
      bidNum: undefined,
      unitPrice: 0.8932,
      TATPrice: 0.8,
      balance: undefined,
      currentcumulativebid: undefined,
      submitBtnText: "Enter an amount",
      account: this.$store.getters.metaMaskObj.account,
      refreshCount: 0
    };
  },
  computed: {
    changeMoney() {
      return (this.unitPrice * (+this.bidNum || 0)).toFixed(2);
    }
  },
  methods: {
    setShowDetail() {
      this.$emit("setShowDetail");
    },
    changeType(data) {
      if (this.currentcumulativebid > 0) {
        return;
      }
      this.type = data;
      this.getBalance();
    },
    async init() {
      try {
        this.loading = true;
        this.contractBid = this.$store.getters.contractMap[
          "contractBid"
        ].contract;
        this.contractBidAddress = this.$store.getters.contractMap[
          "contractBid"
        ].address;

        this.contractTAT = this.$store.getters.contractMap[
          "contractTAT"
        ].contract;
        this.contractTATAddress = this.$store.getters.contractMap[
          "contractTAT"
        ].address;

        this.contractUnitPrice = this.$store.getters.contractMap[
          "contractUnitPrice"
        ].contract;
        this.contractUnitPriceAddress = this.$store.getters.contractMap[
          "contractUnitPrice"
        ].address;

        this.currentcumulativebid = 0;
        this.bidNum = undefined;
        this.getIsTATBider();
        this.getBalance();
        this.getUnitPrice();
        // this.getTATPrice()
        this.refreshCurrentcumulativebid();

        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    async getBalance() {
      try {
        if (this.type == "UNIT") {
          this.balance = await web3.eth.getBalance(this.account);
        } else {
          this.balance = await this.contractTAT.methods["balanceOf"](
            this.account
          ).call({
            from: this.account
          });
        }
      } catch (e) {
        console.log("1", e);
      }
    },
    async getUnitPrice() {
      try {
        this.unitPrice = await this.contractUnitPrice.methods[
          "getCurrencyValue"
        ](this.UNITVal).call({
          from: this.account
        });
      } catch (e) {
        console.log("2", e);
      }
    },
    async getTATPrice() {
      try {
        this.TATPrice = await this.contractUnitPrice.methods[
          "getCurrencyValue"
        ]("TAT").call({
          from: this.account
        });
      } catch (e) {
        console.log("2", e);
      }
    },
    async refreshCurrentcumulativebid() {
      await this.getCurrentcumulativebid();
      if (this.currentcumulativebid != "0") {
        this.refreshTimmer = setTimeout(() => {
          this.refreshCurrentcumulativebid();
          this.$emit("refreshChart");
        }, 2000);
      }
    },
    async getCurrentcumulativebid() {
      try {
        let res = await this.contractBid.methods["getBidData"](
          this.account
        ).call({
          from: this.account
        });
        this.currentcumulativebid = res.amount || "0";
      } catch (e) {
        console.log("3", e);
      }
    },
    async getIsTATBider() {
      try {
        let isTAT = await this.contractBid.methods["isTATBider"](
          this.account
        ).call({
          from: this.account
        });
        let isUnit = await this.contractBid.methods["isUnitBider"](
          this.account
        ).call({
          from: this.account
        });
        if (isTAT) {
          this.type = "TAT";
        } else if (isUnit) {
          this.type = "UNIT";
        }
      } catch (e) {
        console.log("4", e);
      }
    },

    checkNumber() {
      if (!isIntNum(+this.bidNum)) {
        this.$message.warning(`Please enter a number`);
        return false;
      }
      if (this.BIGNUM.toSmallNum(this.balance) < this.bidNum) {
        this.submitBtnText = "Insufficient Rep/UNIT balance";
        return false;
      }
      if (+this.bidNum <= 0) {
        this.bidNum = undefined;
        this.submitBtnText = "Enter an amount";
        return false;
      } else {
        this.submitBtnText = "Submit";
        return true;
      }
    },
    async submit(btn) {
      try {
        if (this.type == "UNIT") {
          if (this.bidNum < 158) {
            this.$message.warning("As a UNIT Validator:minimum bid 158 UNIT");
            btn.closeLoad();
            return;
          }
          const tx_builder = this.contractBid.methods["bidUnit"]();
          const encoded_tx = tx_builder.encodeABI();
          web3.eth
            .sendTransaction({
              gas: this.$store.getters.gas,
              from: this.account,
              to: this.contractBidAddress,
              value: toBigNum(this.bidNum),
              data: encoded_tx
            })
            .then(res => {
              btn.closeLoad();
              this.init();
              this.refresh();
              this.$message.success(
                "You have successfully participated in BID！"
              );
            })
            .catch(error => {
              this.$message.error("operation failed");
              console.error(error);
              btn.closeLoad();
            });
        } else if (this.type == "TAT") {
          if (+this.bidNum < 1) {
            this.$message.warning("As a Rep Validator: minimum bid 1 TAT");
            btn.closeLoad();
            return;
          } else if (+this.bidNum > 10000) {
            this.$message.warning("As a Rep Validator: not more than 10000");
            btn.closeLoad();
            return;
          }
          const tx_builder = this.contractBid.methods["bidTAT"](
            toBigNum(this.bidNum)
          );
          const encoded_tx = tx_builder.encodeABI();
          web3.eth
            .sendTransaction({
              gas: this.$store.getters.gas,
              from: this.account,
              to: this.contractBidAddress,
              value: 0,
              data: encoded_tx
            })
            .then(res => {
              btn.closeLoad();
              this.init();
              this.refresh();
              this.$message.success(
                "You have successfully participated in BID！"
              );
            })
            .catch(error => {
              this.$message.error("operation failed");
              console.error(error);
              btn.closeLoad();
            });

          // await this.contractBid.methods["bidTAT"](this.bidNum).call({
          //   from: this.account
          // });
          // btn.closeLoad();
          // this.init();
          // this.refresh();
          // this.$message.success("You have successfully participated in BID！");
        }
      } catch (e) {
        btn.closeLoad();
        this.$message.error("operation failed");
        console.log(e);
      }
    },
    refresh() {
      this.$emit("refresh");
    }
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    window.clearTimeout(this.refreshTimmer);
  }
};
</script>
<style scoped lang="scss">
.des {
  color: #929dad;
  font-size: 0.22rem;
  line-height: 0.32rem;
}
.bid-now {
  max-width: 6.4rem;
  height: 6.53rem;
  margin: 0 auto;
  background: linear-gradient(
    180deg,
    #f5f5f5 0%,
    #f5f5f5 0%,
    #fafafa 56%,
    #ffffff 100%
  );
  box-shadow: 0px 16px 40px 0px rgba(6, 16, 32, 0.1);
  // padding: 0.4rem;
  box-sizing: border-box;
  border: 3px solid #ffffff;
  border-radius: 0.24rem;
}
.bid-title {
  font-size: 0.32rem;
  font-weight: 500;
  color: #1f1f1f;
  line-height: 1.04rem;
  border-bottom: 1px solid #929dad;
  svg {
    margin-right: 0.12rem;
  }
}
.unit-input {
  padding: 0.4rem;
  .exchange-item {
    background: #fff;
    padding: 0.24rem 0.2rem;
    min-width: 5.6rem;
    margin-bottom: 0.16rem;
  }
  .exchange-jiantou {
    width: 0.56rem;
    position: absolute;
    left: 50%;
    margin-left: -0.28rem;
    margin-top: -0.34rem;
  }
  .exchange-input {
    /deep/ .el-input__inner {
      border: none;
      text-align: right;
      font-size: 0.36rem;
      font-weight: 500;
      color: #1f1f1f;
      padding: 0 0;
      font-family: DMSans-Medium;
    }
  }
  .word-sm {
    font-size: 0.18rem;
    font-weight: 400;
    color: #aaaaaa;
    line-height: 0.2rem;
    margin-bottom: 0.13rem;
  }
  .word-sm-black {
    font-size: 0.2rem;
    font-weight: 500;
    color: #1f1f1f;
  }
  .word-big-num {
    font-size: 0.36rem;
    font-weight: 500;
    color: #1f1f1f;
    line-height: 0.42rem;
  }
  .unit-icon {
    padding: 0.18rem 0.16rem;
    background: #f1f2f5;
    border-radius: 0.08rem;
  }
  .bid-input-tip {
    font-size: 0.22rem;
    font-weight: 400;
    color: #929dad;
    line-height: 0.32rem;
  }
}
.checkLoginBtn {
  padding: 0 0.4rem;
  box-sizing: border-box;
}
.word-sm {
  font-size: 0.18rem;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 0.2rem;
}
</style>
